export default __webpack_public_path__ + "static/NuvemFiscalCEP-86d12b83d54b27851ecb085d0346ee99.png";